import { ArrowBackOutline } from '@styled-icons/evaicons-outline/ArrowBackOutline'
import * as React from 'react'
import CanvasDraw from 'react-canvas-draw'
import styled from 'styled-components'

import type { IPatient } from '@app/domain/patient/patient.interface'
import { theme } from '@app/utils/theme'

import { ScreenContent } from './content-layout'
import {
  BackButton,
  ClearButton,
  ContinueButton,
  ControlRow,
  Control,
} from './controls'

const SignatureContainer = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  max-width: 500px;
`

const ScreenHeaderRow = styled.div`
  width: 100%;
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  justify-content: center;
`
const ScreenHeader = styled.div`
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
  font-size: 16pt;
  font-weight: 500;
`

const Signature = styled.div`
  width: 502px;
  border: 1px solid ${(props) => props.theme.colors.primary};
  border-radius: 10px;
  padding-left: 5px;
`

interface IntakeSignatureProps {
  header?: string
  patient: IPatient
  handleContinue?: (patient: IPatient, signature: string) => void
}

interface IntakeSignatureState {
  signature?: string
}

export class IntakeSignature extends React.Component<
  IntakeSignatureProps,
  IntakeSignatureState
> {
  constructor(props) {
    super(props)
    this.state = {
      signature: null,
    }
  }

  renderBackButton = (goBack?: () => void) => {
    if (goBack) {
      return (
        <BackButton onClick={goBack}>
          <ArrowBackOutline size="45" />
        </BackButton>
      )
    } else {
      return <></>
    }
  }

  renderHeader = (header?: string) => {
    if (header) {
      return (
        <ScreenHeaderRow>
          <ScreenHeader dangerouslySetInnerHTML={{ __html: header }} />
        </ScreenHeaderRow>
      )
    } else {
      return <ScreenHeaderRow />
    }
  }

  renderSignatureCanvas = (ref: React.RefObject<CanvasDraw>) => {
    return (
      <>
        <Signature>
          <CanvasDraw
            ref={ref}
            onChange={() => this.saveSignature(ref)}
            brushRadius={2}
            lazyRadius={4}
            hideGrid={true}
            canvasHeight={245}
            canvasWidth={490}
            caternaryColor={theme.colors.primary}
          />
        </Signature>
      </>
    )
  }

  renderContinueButton = () => {
    return (
      <ContinueButton
        onClick={() =>
          this.props.handleContinue(this.props.patient, this.state.signature)
        }
      >
        Submit
      </ContinueButton>
    )
  }

  clearSignature = (ref: React.RefObject<CanvasDraw>) => {
    if (ref.current) {
      ref.current.clear()
      this.setState({
        signature: null,
      })
    }
  }

  saveSignature = (ref: React.RefObject<CanvasDraw>) => {
    if (ref.current) {
      this.setState({
        signature: ref.current.canvas.drawing.toDataURL(), //base64 encoded png dat
      })
    }
  }

  render() {
    const { header } = this.props
    const canvasRef = React.createRef()
    return (
      <ScreenContent>
        <SignatureContainer>
          {this.renderHeader(header)}
          {this.renderSignatureCanvas(canvasRef)}
          <ClearButton onClick={() => this.clearSignature(canvasRef)}>
            Clear Signature
          </ClearButton>
        </SignatureContainer>
        <ControlRow>
          <Control>
            {this.state.signature ? this.renderContinueButton() : <></>}
          </Control>
        </ControlRow>
      </ScreenContent>
    )
  }
}
